export default {
  info: '/v3/recruit/queue/info',
  createOrder: '/v3/recruit/queue/createOrder',
  getRightsInfo: '/v3/recruit/queue/getRightsInfo',
  detail: '/v3/recruit/equipment/payment/detail'
}
